import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Localization from '@/views/Localization'
import Team from '@/views/Team'
import Plot from '@/views/Plot'
import Map from '@/views/Map'
import PlotType from '@/views/PlotType'
import Settings from '@/views/Settings'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/localization',
      name: 'Localization',
      component: Localization
    },
    {
      path: '/team',
      name: 'Team',
      component: Team
    },
    {
      path: '/plot',
      name: 'Plot',
      component: Plot
    },
    {
      path: '/map',
      name: 'Map',
      component: Map
    },
    {
      path: '/area',
      name: 'Area',
      component: Map
    },
    {
      path: '/plotType',
      name: 'PlotType',
      component: PlotType
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    }
  ]
})
